/**
 * Salva o XML da nota fiscal no disco. O nome é montado aqui porque o CORS da API não expõe
 * o Content-Disposition de GET /user/invoices/{id}/nf-xml.
 */
export function saveNfseXml(blob: Blob, invoiceId: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `nfse-${invoiceId}.xml`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 200);
}
